module.exports = __webpack_public_path__ + "img/shoutouts.01f26337.jpg";